import { render, staticRenderFns } from "./CitiesSelect.vue?vue&type=template&id=5ba3fc63&scoped=true&"
import script from "./CitiesSelect.vue?vue&type=script&lang=js&"
export * from "./CitiesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba3fc63",
  null
  
)

export default component.exports